module.exports = "/assets/about/success/fba2022.png?FSgvp2V";